import { render, staticRenderFns } from "./BannerV2Block.vue?vue&type=template&id=47961640&scoped=true&"
import script from "./BannerV2Block.vue?vue&type=script&lang=js&"
export * from "./BannerV2Block.vue?vue&type=script&lang=js&"
import style0 from "./BannerV2Block.vue?vue&type=style&index=0&id=47961640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47961640",
  null
  
)

export default component.exports